


app.filter('acTimeFilter', ["$filter",function myDateFormat($filter){
  return function(text){
    var  tempdate= new moment(text, "YYYY-MM-DD HH:mm:ss").toDate();
    return $filter('date')(tempdate, "HH:mm");
  }
}]);

app.filter('acDayFilter', ["$filter",function myDateFormat($filter){
  return function(text){
    var  tempdate= new moment(text, "YYYY-MM-DD HH:mm:ss").toDate();
    return $filter('date')(tempdate, "dd.MM");
  }
}]);

app.filter('acDateFilter', ["$filter",function myDateFormat($filter){
  return function(text){
    var  tempdate= new Date(text);
    return $filter('date')(tempdate, "dd.MM.yyyy");
  }
}]);